'use client'

import NextLink from 'next/link'
import { useState, type ReactNode } from 'react'

type LinkProps = {
  href: string
  children: ReactNode
  className?: string
  onClick?: () => void
}

export default function Link({ href, children, className, onClick }: LinkProps) {
  const [shouldPrefetch, setShouldPrefetch] = useState(false)

  return (
    <NextLink
      href={href}
      prefetch={shouldPrefetch || undefined}
      onMouseEnter={() => {
        console.log('onMouseEnter', href)
        setShouldPrefetch(true)
      }}
      className={className}
      onClick={onClick}
    >
      {children}
    </NextLink>
  )
}